import React from 'react';
import ChequeredChess from './ChequeredChess';
import { useRoomContext } from '@livekit/components-react';

interface ChequeredChessWrapperProps {
    subscriptionId: string;
    subscriptionName: string;
    userRole?: string;
    participantName?: string;
}

/**
 * Wrapper component that handles LiveKit context detection
 * Can be used both inside and outside of LiveKit meetings
 */
const ChequeredChessWrapper: React.FC<ChequeredChessWrapperProps> = (props) => {
    // Try to get room context, but handle gracefully if not in a meeting
    const room = null;
    const isInMeeting = false;
    
    // Always call the hook (React requirement), but handle the case where we're not in a LiveKit context
    // The useRoomContext will throw if not inside LiveKitRoom, so we catch it
    // We'll use a different approach - just pass null and let the component handle it
    
    return (
        <ChequeredChess
            {...props}
            isInMeeting={false}  // Will be true when inside LiveKit meeting context
            room={null}  // Will be populated when inside LiveKit meeting
        />
    );
};

export default ChequeredChessWrapper;

